import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=b04e12f0&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=ts&"
export * from "./Files.vue?vue&type=script&lang=ts&"
import style0 from "./Files.vue?vue&type=style&index=0&id=b04e12f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04e12f0",
  null
  
)

export default component.exports